<div class="card height-100">

    <!--    Shipment Type & Invoice Number-->
    <div class="p-grid">
        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Type
            </div>
            <div class="p-mt-1">
                {{invoice?.shipmentType ? invoice?.shipmentType : '-'}}
            </div>
        </div>

        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Invoice Number
            </div>
            <div class="p-text-bold p-mt-1">
                <div class="p-d-flex p-ai-center">
                    <div class="p-text-secondary">
                        {{invoice?.invoiceNumber ? invoice?.invoiceNumber : '-'}}
                    </div>
                    <div class="p-ml-1 p-cursor p-text-secondary">
                        <img (click)="handleClickActions('view-document', invoice)" class="p-cursor"
                             src="assets/branding/shared-icons/view.svg" alt=""
                             style="height: 1.3rem;">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--    Invoice Date & Booking Number-->
    <div class="p-grid p-mt-2">
        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Invoice Date
            </div>
            <div class="p-mt-1">
                {{invoice?.invoiceDate ? (invoice?.invoiceDate | date: 'dd-MMM-yyyy') : '-'}}
            </div>
        </div>

        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Booking Number
            </div>
            <div
                    class="p-d-flex p-ai-center p-jc-start">
                <div>
                    {{invoice?.bookingId ? invoice?.bookingId : '-'}}
                </div>

                <div class="p-ml-2 p-cursor"
                     *ngIf="invoice?.bookingsCount > 0">
                    <p-badge (mouseenter)="invoice.showMultipleBookings = true"
                             (mouseleave)="invoice.showMultipleBookings = false"
                             [value]="'+'+invoice?.bookingsCount"></p-badge>

                </div>
            </div>
            <div *ngIf="invoice.showMultipleBookings">
                <div class="p-mt-2" *ngFor="let bookingNumbers of invoice.multipleBookingNumbers?.split(',')">
                    {{bookingNumbers}}
                </div>
            </div>
        </div>
    </div>

    <!--    Customer Reference Number & Transport Document-->
    <div class="p-grid p-mt-2">
        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Customer Ref. No.
            </div>
            <div class="p-mt-1">
                {{invoice?.customerReferenceNumber ? invoice?.customerReferenceNumber : '-'}}
            </div>
        </div>

        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Transport Document
            </div>
            <div class="p-mt-1">
                {{invoice?.transportDocuments ? invoice?.transportDocuments : '-'}}
            </div>
        </div>
    </div>

    <!--    Bill To & Invoice Amount-->
    <div class="p-grid p-mt-2">
        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Bill To
            </div>
            <div class="p-mt-1">
                {{invoice?.billTo ? invoice?.billTo : '-'}}
            </div>
        </div>

        <div class="p-col-6">
            <div class="p-header-font-size p-text-secondary p-text-bold">
                Invoice Amount
            </div>
            <div class="p-mt-1">
                {{invoice?.formattedInvoiceAmount ? invoice?.formattedInvoiceAmount : '-'}}
            </div>
        </div>
    </div>
</div>
